import axios from 'axios'

interface IAuth {
  token: string;
  nome: string;
  sucesso: boolean;
  mensagem: string;
  codigoPessoFisica: number;
}

const postLogin = async (usuario: string, senha: string): Promise<IAuth | Error> => {

  try {

    const http = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    const response = await http.post<IAuth>(`/sam/v1/login`, { usuario, senha });

    if (response != null && response.data.sucesso) {
      return response.data;
    } else if (response != null && response.data.mensagem !== "") {
      return new Error(response.data.mensagem)
    } else {
      return new Error("Ocorreu um erro na realização do login")
    }

  } catch (e: any) {
    return new Error(`Ocorreu um erro na realização do login: ${e}`)
  }
};

export const LoginService = {
  postLogin
} 